export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20living%20room%20atmosphere%20with%20soft%20amber%20lighting%2C%20comfortable%20seating%2C%20entertainment%20system%2C%20immersive%20viewing%20experience%2C%20dark%20warm%20tones%2C%20high%20quality%20interior%20photography%2C%20cinematic%20mood%2C%20professional%20lighting%2C%20no%20people%20visible&width=1200&height=800&seq=about-platform-2026&orientation=landscape"
                alt="向日葵视频平台介绍 - 家庭影院观影体验"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
              关于平台
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              关于向日葵视频
            </h2>
            <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                向日葵视频是一个综合性的免费在线观影平台，致力于为用户提供
                <strong>榴莲视频、红杏视频</strong>等热门平台的最新影视资源。
                我们聚合全网优质内容，涵盖<strong>电影、电视剧、综艺、动漫</strong>
                等多种类型，满足不同用户的观影需求。
              </p>
              <p>
                平台采用先进的<strong>多线路智能调度技术</strong>，确保高清视频
                流畅播放不缓冲，让每一位用户都能享受到影院级的在线观看体验。
                向日葵视频始终秉持"免费、高清、流畅"的核心原则，
                持续扩充片库、优化播放体验，立志成为最受欢迎的中文在线影视平台。
              </p>
              <p>
                无论是追最新热播剧集，还是重温经典老片，向日葵视频都为你
                准备好了最佳的在线播放方案 — 无需注册、无需付费、即点即看。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-4">
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="text-2xl font-bold text-primary-600">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="text-2xl font-bold text-accent-600">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">播放成功率</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="text-2xl font-bold text-secondary-600">24h</div>
                <div className="text-xs text-foreground-500 mt-1">同步更新</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}